import {createAsyncThunk} from '@reduxjs/toolkit';
import {getFcmToken} from 'services/auth-service';

const retrieveFcmToken = createAsyncThunk('auth/retrieveFcmToken', async () => {
  const fcmToken = await getFcmToken();
  return fcmToken;
});

export default retrieveFcmToken;
